module.exports = __webpack_public_path__ + "static/media/2012_maleRate_femaleRate.589739ee.png";